import { IProvince } from "Models/province";
import customFetchBase from "./customFetchBase";
import { createApi } from "@reduxjs/toolkit/query/react";


export const provinceApi = createApi({
    reducerPath: "provinceApi",
    baseQuery: customFetchBase,
    tagTypes: ["Province"],
    keepUnusedDataFor: 300,  // Keep cached data for 5 minutes globally
    refetchOnReconnect: true, // Refetch data when reconnected to the network
    refetchOnFocus: true, // Refetch data when the window is focused again
    endpoints: (builder) => ({
        getAllProvinces: builder.query<IProvince[], void>({
            query() {
                return {
                    url: "provinces/",
                    method: "GET",
                    credentials: "include",
                };
            },
            providesTags: () => [{ type: "Province" }],
            transformResponse: (results: { data: IProvince[] }) => {
                return results.data;
            },
        }),
        getAProvince: builder.query<IProvince, string>({
            query(id) {
                return {
                    url: `provinces/${id}`,
                    method: "GET",
                    credentials: "include",
                };
            },
            providesTags: ["Province"],
            transformResponse: (result: { data: IProvince }) => {
                    return result.data;
                  },
        }),
    }),
});
export const { useGetAllProvincesQuery, useGetAProvinceQuery } = provinceApi;